/* tslint:disable */
/* eslint-disable */
export enum RoofProductTypeEnum {
  Tile = 'tile',
  Accessory = 'accessory',
  RainSystem = 'rainSystem',
  FenceSlats = 'fenceSlats',
}
